import * as clients from './configs';
import { Features } from './type';
import defaultFeatureState from './default';
import { isCapacitor } from '@zignaly-open/ui';
import { MIN_INVESTMENT_FIREBLOCKS } from 'util/constants';

const { VITE_DEV_ONLY_WHITELABEL: whitelabelNameOverride } = import.meta.env;

export const whitelabel =
  window.__zignalyWhitelabelConfig ||
  (whitelabelNameOverride && clients[whitelabelNameOverride]) ||
  clients.zignaly;

export const isZignaly = /^z0\d+$/.test(whitelabel.slug);
const isZignalyStaging =
  whitelabel.baseApi === 'https://staging-api.zignaly.com/';

export const isMaintenanceModeFromServer = whitelabel.isMaintenance;

export const isFeatureOn = (feature: Features): boolean => {
  return (
    {
      ...defaultFeatureState,
      ...(whitelabel?.featureOverrides || {}),
    }[feature] || false
  );
};

export const isAccountRequired =
  isFeatureOn(Features.LoginOnlyAccess) || isCapacitor;

export function getMinInvestmentAmountFireblocks() {
  return isZignalyStaging ? 1 : MIN_INVESTMENT_FIREBLOCKS;
}

export function getMinInvestmentAmount(coin: string): number {
  if (
    isFeatureOn(Features.MinInvestment) &&
    +whitelabel.minInvestment?.[coin] > getMinInvestmentAmountFireblocks()
  ) {
    return +whitelabel.minInvestment?.[coin];
  }
  return getMinInvestmentAmountFireblocks();
}

export const minZScore = whitelabel.marketplaceMinScore ?? 20;

export const supportsNonCryptoServices = isZignaly;

export const googleClientId = whitelabel.oauthProviders?.find(
  (x) => x.name === 'google',
)?.client_id;

export const isGoogleLoginEnabled = !!googleClientId;

export const whitelabelSpecificSwitches = {
  showLaptopOnSignup: whitelabel.slug !== 'mindvest',
  signupDisabled: whitelabel.slug === 'criptomaniacos',
  allowCustomServiceImages: true,
};

export const shouldUseServiceWorker =
  isFeatureOn(Features.ServiceWorker) && !isMaintenanceModeFromServer;

export const useZIndexes = true;
